import { useApplicationContext } from "components/Application";
import { Footer } from "components/Footer";
import React from "react";
import { useTranslation } from "react-i18next";

import "twin.macro";

export const Profile: React.FC<{}> = () => {
  const { i18n } = useTranslation();
  const { session } = useApplicationContext();

  const { currentUser } = session;

  return (
    <div tw="flex space-x-2">
      <div tw="flex flex-col space-x-2 w-full">
        <div>
          <div tw="flex w-full justify-between px-6">
            <div tw="text-gray-500">{i18n.language === "it" ? "IL TUO PROFILO" : "YOUR PROFILE"}</div>
          </div>
        </div>
        <div tw="flex px-16 flex-col space-x-0 space-y-12 w-full mx-4" style={{ margin: "4rem auto" }}>
          <div tw="w-full max-w-sm">
            <p tw="font-bold text-2xl">{i18n.language === "it" ? "PROFILO UTENTE" : "USER PROFILE"}</p>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Utente/Email" : "Username/Email"}</p>
              <p>{currentUser.email}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Ragione Sociale" : "Company Name"}</p>
              <p>{currentUser.companyName}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Indirizzo" : "Address"}</p>
              <p>{currentUser.address}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Città" : "City"}</p>
              <p>{currentUser.city}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Cap" : "Zip"}</p>
              <p>{currentUser.zip}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Provincia" : "Province"}</p>
              <p>{currentUser.province}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Nazione" : "Country"}</p>
              <p>{currentUser.country}</p>
            </div>
            <div tw="flex justify-between">
              <p tw="font-bold">{i18n.language === "it" ? "Partita IVA" : "Vat Number"}</p>
              <p>{currentUser.vatNumber}</p>
            </div>
            <div tw="flex justify-between">
              <p>
                {i18n.language === "it"
                  ? "Se hai bisogno di aggiornare la tua anagrafica"
                  : "Do you need to update you profile?"}
              </p>
              <p tw="font-bold underline">
                <a href="mailto:sales@pgninternational.it?subject=Richiesta di modifica Anagrafica">
                  {i18n.language === "it" ? "Clicca qui" : "click here"}
                </a>
              </p>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
